<script>
    import { onMount } from 'svelte';
    import Id from '/srv/web/wyvr/html/releases/58819/gen/client/shop/stores/id.js?1733898724584';

    export let open = false;
    export let id = 'dialog';
    export let title = undefined;
    export let description = undefined;
    export let scroll = true;
    export let onKeyDown = undefined;
    export let cssClass = undefined;

    let enabled = false;
    let internal_id = '';
    let close;
    let close_content;
    onMount(() => {
        enabled = true;
        internal_id = id + Id();

        close_content = close?.innerHTML;

        function handleKeydown(event) {
            if (event.key === 'Escape') {
                open = false;
                return;
            }
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
            }
        }

        window.addEventListener('keydown', handleKeydown);

        return () => {
            window.removeEventListener('keydown', handleKeydown);
        };
    });
    $: internal_title_id = title ? internal_id + '_title' : undefined;
    $: internal_desc_id = description ? internal_id + '_desc' : undefined;
</script>

<div style="display:none" bind:this={close}><slot name="close" /></div>
{#if enabled}
    <section
        class="c-dialog-wrapper {cssClass}"
        role="dialog"
        open={open ? true : undefined}
        aria-labelledby={internal_title_id}
        aria-describedby={internal_desc_id}
    >
        <div class="dialog">
            <header class="dialog-header">
                {#if title}
                    <section id={internal_title_id}>{@html title}</section>
                {/if}
                <button
                    class="btn close icon-close"
                    aria-label={window.__('shop.close')}
                    on:click={() => {
                        open = false;
                    }}
                    >{#if close_content}{@html close_content}{/if}</button
                >
            </header>
            <div class="content" class:scroll>
                {#if description}
                    <p id={internal_desc_id}>{description}</p>
                {/if}
                <slot />
            </div>
        </div>
        <button
            class="backdrop"
            on:click={() => {
                open = false;
            }}>{window.__('shop.close')}</button
        >
    </section>
{/if}


<style>
    
    .backdrop {     background: rgba(0,0,0,.5);     position: absolute;     top: 0;     left: 0;     z-index: 100000;     border: none;     display: block;     width: 100%;     height: 100%;     cursor: pointer; } 
    section[role='dialog'] {     position: fixed;     top: 0;     right: 0;     bottom: 0;     left: 0;     z-index: 100000;     display: none; } section[role='dialog'][open] {     display: block; } .dialog {     position: absolute;     top: 50%;     left: 50%;     z-index: 100001;     transform: translate(-50%, -50%);     max-width: 90vw;     max-height: 90vh;     background: #fff;     color: #000;     --color-text: #000;     display: flex;     flex-direction: column; } 

    .dialog {
        width: 100%;
        max-width: 600px;
        max-height: 90vh;
        box-shadow: 0 16px 16px rgba(0, 0, 0, 0.3);
    }

    header {
        text-align: center;
        font-size: 1.25rem;
        border-bottom: 1px solid #eeeeee;
    }
    .scroll {
        overflow: auto;
        max-height: 100%;
    }
    .dialog .close {
        background-color: #040b1c;
        font-size: 1rem;
        display: flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        border: 1px solid transparent;
        transition: 1s;
    }
    .content {
        padding: 0 2rem 1rem 2rem;
    }
    .dialog .close:hover {
        color: #fef8e9;
        background: #707070;
        border: 1px solid #707070;
        text-decoration: none;
        outline: none;
        transition: 1s;
    }

    .dialog .close::before {
        font-family: 'kofferworld' !important;
        color: white;
        font-size: 8px;
        font-weight: bold;
    }

    .dialog header section:first-child {
        font-size: 1.875rem;
    }

    section header {
        display: flex;
        font-size: 1.875rem;
        padding: 1rem 2rem;
        justify-content: space-between;

        flex-wrap: wrap-reverse;
        font-size: var(--h2__font-size);
        font-weight: var(--h2__font-weight);
        line-height: var(--h2__line-height);
        color: var(--h2__color);
        margin: var(--h2__margin);
        text-transform: var(--font-heading-text-transform);
        margin: 0;
    }

    .dialog :global(.footer) {
        display: flex;
        justify-content: flex-end;
        padding-top: 1rem;
        margin-top: 1rem;
        border-top: 1px solid var(--whitegray);
        gap: 1rem;
    }
</style>